/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {IRoom} from 'interfaces';
import {
  ROOM_DETAILS_FETCHING,
  ROOM_DETAILS_FETCHING_DONE,
  ROOM_DETAILS_FETCHING_ERROR,
  RoomsActions
} from 'store/action/rooms';
import {IPortalError} from 'utility/error-handler';

export interface IRoomDetailsState {
  roomDetails: IRoom | null;
  isFetching: boolean;
  error: null | IPortalError;
}

const initialRoomDetailsState = {
  roomDetails: null,
  isFetching: false,
  error: null
};
const roomDetailsReducer: Reducer<Readonly<IRoomDetailsState>, RoomsActions> = (
  state: IRoomDetailsState = initialRoomDetailsState,
  action: RoomsActions
) => {
  switch (action.type) {
    case ROOM_DETAILS_FETCHING:
      return {
        ...state,
        error: null,
        isFetching: true
      };
    case ROOM_DETAILS_FETCHING_ERROR:
      return {
        ...state,
        error: action.error,
        isFetching: false
      };
    case ROOM_DETAILS_FETCHING_DONE:
      return {
        ...state,
        roomDetails: action.payload,
        error: null,
        isFetching: false
      };
    default:
      return state;
  }
};

export default roomDetailsReducer;